import React, { useContext, useState } from 'react';
import {
  AppContext,
  NO_ITEM_TAX_CLIENTS,
  getTranslatedText,
  formatDataForSelectDropdown,
  DropdownIndicator,
  formatGroupLabel,
  IndicatorSeparator
} from '@nile/components';
import { Dropdown } from '@superops/ui-design-system';
import { SVGIcon } from '@superops/super-icons';
import { includes, omit } from 'lodash';
import { useLazyQuery } from '@apollo/client';
import { getTotalValue } from '@nile/banyan/src/Pebbles/tax';
import { GET_ALL_TAX, AccountClient } from '@nile/graphql';
import styled from 'styled-components';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { injectIntl } from 'react-intl';

const Wrap = styled.div`
  display: flex;
  align-items: center;
  .edit-actions {
    visibility: hidden;
    cursor: pointer;
  }
  padding-left: 8px;
  padding-right: 8px;
  max-width: 100%;
  white-space: ${(props) => (props.wrap ? 'normal' : 'nowrap')};
`;

function TotalCell(props) {
  const { user } = useContext(AppContext);
  const flags = useFlags();
  const clientLocation = user?.site?.countryCode || false;
  const isTaxForIndividualItemsNotAllowed = false;
  // includes(
  //   NO_ITEM_TAX_CLIENTS,
  //   clientLocation
  // );
  const [clicked, setClicked] = useState(false);
  const [allTaxData, setAllTaxData] = useState(null);
  const [
    getAllTax,
    { loading: taxLoading, error: taxError, data: taxData }
  ] = useLazyQuery(GET_ALL_TAX, {
    client: AccountClient,
    onCompleted(response) {
      setAllTaxData(response?.getAllTax);
    }
  });
  const taxRateList = taxData
    ? formatDataForSelectDropdown(taxData?.getAllTax)
    : [];
  const { cell, intl } = props;
  const allProps = cell.column;
  const {
    editable,
    field,
    actions,
    accessor,
    entity,
    editMode,
    clientId
  } = allProps;

  const value = cell.row.original;
  const allValues = cell.column.allData;
  const isTaxable = value.taxable;

  let displayVal = '';

  allValues.taxes
    .filter((el) => el.tax.taxId === value?.tax?.taxId)
    .forEach((el) => {
      if (!displayVal) {
        displayVal = 0;
      }
      displayVal += el.taxRate ? Number(el.taxRate) : 0;
    }, 0);

  if (displayVal || displayVal === 0) displayVal += '%';

  const getTaxEditSection = () => {
    return (
      <>
        <Dropdown
          className="rule-fields"
          value={
            (isTaxable &&
              taxRateList.find(
                (el) => el.taxId === cell?.row?.original?.tax?.taxId
              )) || {
              ...cell?.row?.original?.tax,
              value: cell?.row?.original?.tax?.name,
              label: cell?.row?.original?.tax?.name
            }
          }
          onMenuOpen={() => {
            getAllTax();
          }}
          onChange={(val) => {
            actions.onChange({
              key: 'tax',
              value: { ...omit(val, ['label', 'value']) },
              field: cell.row.original
            });
          }}
          classNamePrefix="value_selector"
          formatGroupLabel={formatGroupLabel}
          components={{ IndicatorSeparator, DropdownIndicator }}
          options={taxRateList}
          menuPortalTarget={document.body}
          menuPlacement="auto"
          closeMenuOnScroll={(e) => {
            return (
              e.target &&
              e.target.classList &&
              !(e.target.classList.value.indexOf('menu-list') > -1)
            );
          }}
          name="valueselector"
          styles={{
            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
            menu: (base) => ({ ...base, zIndex: 9999 })
          }}
          noOptionsMessage={() => {
            return taxLoading ? 'Loading...' : 'No options';
          }}
        />
      </>
    );
  };
  return (
    <Wrap className="cell">
      {editable && editMode ? (
        getTaxEditSection()
      ) : (
        <div>{isTaxable && displayVal ? displayVal : 'NA'}</div>
      )}
    </Wrap>
  );
}

export default injectIntl(TotalCell);
